import { NgModule } from '@angular/core';
import { RefreshableFrameComponent } from './refreshable-frame.component';

@NgModule({
  declarations: [
    RefreshableFrameComponent
  ],
  exports: [
    RefreshableFrameComponent
  ]
})
export class RefreshableFrameModule {}
